'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {LabeledBlock} from '../../../components/forms/LabeledBlock';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {TaskDate} from '../TaskDate';


export function BaseTaskDateFieldView(props) {
  return (
    <LabeledBlock
      className={classNames("TaskDateField", props.className)}
      label={props.label}
      onClick={props.onClick}
    >
      <TaskDate
        date={props.date}
        useTime={props.useTime}
        placeholder={props.notScheduledLabel}
      />
    </LabeledBlock>
  );
}

BaseTaskDateFieldView.propTypes = {
  className: T.string,
  label: T.string.isRequired,
  date: T.oneOfType([
    T.number,
    T.instanceOf(Date),
  ]),
  useTime: T.bool,
  notScheduledLabel: T.string,
};

BaseTaskDateFieldView.defaultProps = {
  className: '',
};

export const TaskDateFieldView = I18nComponent(BaseTaskDateFieldView, [
  {code: 'schedule.not_scheduled.label', prop: 'notScheduledLabel'},
  {prop: 'label', dynamic: getCode},
]);

function getCode(props) {
  return {
    code: props.label,
  };
}



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskDateField/TaskDateFieldView.js